// Icon set: lucide-react (stroke icons), exposed by semantic name so call sites stay stable.
// Decorative: always paired with a text label or an aria-label on the control.
import {
  Bell,
  Bot,
  BriefcaseBusiness,
  Building2,
  ChevronRight,
  Cog,
  Compass,
  Home,
  Inbox,
  LayoutGrid,
  LogOut,
  Megaphone,
  Menu,
  MessageSquare,
  Monitor,
  Moon,
  PenLine,
  Search,
  Sun,
  User,
  Users,
  X,
  Zap,
  ChartNoAxesCombined,
  type LucideIcon,
} from 'lucide-react';

export const ICONS = {
  inbox: Inbox,
  grid: LayoutGrid,
  cog: Cog,
  search: Search,
  bolt: Zap,
  bell: Bell,
  door: LogOut,
  menu: Menu,
  close: X,
  sun: Sun,
  moon: Moon,
  monitor: Monitor,
  user: User,
  chevron: ChevronRight,
  home: Home,
  network: Users,
  jobs: BriefcaseBusiness,
  messages: MessageSquare,
  compass: Compass,
  building: Building2,
  megaphone: Megaphone,
  chart: ChartNoAxesCombined,
  pen: PenLine,
  bot: Bot,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS;

export function Icon({
  name,
  size = 20,
  className,
}: {
  name: IconName;
  size?: number;
  className?: string;
}) {
  const I = ICONS[name];
  return <I size={size} strokeWidth={1.75} aria-hidden="true" focusable="false" className={className} />;
}
